
export default {
    setContrato(state, data) {
        state.contrato = data
    },
    setContratos(state, data) {
        state.contratos = data
    },
}